import React, { useState } from 'react';
import Button from '../../../../shared/components/Button/Button';
import EmptyState from '../../../../shared/components/EmptyState/EmptyState';
import Input from '../../../../shared/components/Input/Input';
import Typography from '../../../../shared/components/Typography/Typography';
import { InsertDriveFileIcon } from './WikiIcons';

const normalizeNextcloudPath = (value = '') => {
  const trimmed = String(value || '').trim().replace(/\\/g, '/');
  if (!trimmed) return '';
  return `/${trimmed.replace(/^\/+/, '').replace(/\/{2,}/g, '/')}`;
};

const getPathLabel = (path) => {
  const name = String(path || '').split('/').filter(Boolean).pop() || path;
  try {
    return decodeURIComponent(name);
  } catch (error) {
    return name;
  }
};

function WikiAttachmentSelector({ value = [], onChange }) {
  const [path, setPath] = useState('');
  const normalizedPath = normalizeNextcloudPath(path);
  const attachments = Array.isArray(value) ? value : [];
  const pathAlreadyAdded = attachments.some(
    (attachment) => normalizeNextcloudPath(attachment.nextCloudPath) === normalizedPath,
  );

  const addPath = () => {
    if (!normalizedPath || pathAlreadyAdded) return;
    onChange([
      ...attachments,
      {
        nextCloudPath: normalizedPath,
        label: getPathLabel(normalizedPath),
      },
    ]);
    setPath('');
  };

  const removePath = (index) => {
    onChange(attachments.filter((attachment, attachmentIndex) => attachmentIndex !== index));
  };

  return (
    <div className="wiki-attachment-selector">
      <div className="wiki-section-header">
        <div>
          <Typography variant="h6">Documents associés</Typography>
          <span className="wiki-selection-count">{attachments.length} chemin(s) renseigné(s)</span>
        </div>
      </div>

      <div className="wiki-attachment-path-form">
        <Input
          fullWidth
          label="Chemin du document dans Nextcloud"
          value={path}
          onChange={(event) => setPath(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              addPath();
            }
          }}
          placeholder="/Wiki/Procédures/Document.pdf"
        />
        <Button variant="secondary" onClick={addPath} disabled={!normalizedPath || pathAlreadyAdded}>
          Ajouter
        </Button>
      </div>

      {pathAlreadyAdded && <small className="wiki-dialog-help">Ce chemin est déjà associé à l’article.</small>}

      <div className="wiki-attachment-list">
        {attachments.map((attachment, index) => (
          <div key={`${attachment.nextCloudPath || attachment.label}-${index}`} className="wiki-attachment-row active">
            <InsertDriveFileIcon fontSize="small" />
            <span>
              <strong>{attachment.label || getPathLabel(attachment.nextCloudPath)}</strong>
              <small>{attachment.nextCloudPath}</small>
            </span>
            <Button size="small" variant="tertiary" onClick={() => removePath(index)}>
              Retirer
            </Button>
          </div>
        ))}
        {!attachments.length && (
          <EmptyState title="Aucun document associé">
            Renseignez le chemin d’un document présent dans Nextcloud.
          </EmptyState>
        )}
      </div>
    </div>
  );
}

export default WikiAttachmentSelector;
